import { Link as RouterLink, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import { Typography, Link } from '@mui/material'

import { HelperWrapper, TextInputWithHelper } from 'src/components'
import { DescriptionGenerateButton } from './description-generate-btn.component'
import { AIGenerateContentPrompt, IProductForm } from 'src/types'
import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'

interface IProps {
  isDisabled?: boolean
  locale?: string
  isRequired?: boolean
  textPrompt?: string
  generationType?: AIGenerateContentPrompt
}

export const DescriptionSimpleInput = ({
  isDisabled,
  locale,
  isRequired = true,
  textPrompt,
  generationType,
}: IProps) => {
  const [t] = useTranslation()
  const { accountId } = useParams()

  const { values, handleChange, errors } = useFormikContext<IProductForm>()

  return (
    <>
      <TextInputWithHelper
        disabled={isDisabled}
        inputName="description"
        handleChange={handleChange}
        value={values.description}
        error={errors.description ? t(errors.description + '.v') : ''}
        inputPlaceholder={t('description-input-placeholder.v')}
        inputUpperLabel={
          <HelperWrapper
            t="description-input-label"
            isMandatory={isRequired}
            isColorInherited
            verticalPosition={15}
            size={12}
          />
        }
        multiline={true}
      />
      <div
        style={{
          display: 'flex',
          gap: '10px',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
          marginTop: '5px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'baseline' }}>
          <Typography variant="body2" sx={{ marginLeft: '20px' }}>
            <HelperWrapper t="editor-rich-upgrade-text" />
            &nbsp;
            <Link
              component={RouterLink}
              to={joinAbsRoute(ROUTES.ACCOUNTS, accountId, `${ROUTES.ACCOUNT}?tab=billing`)}
            >
              <HelperWrapper t="upgrade-button-text" isColorInherited />
            </Link>
          </Typography>
        </div>
        <DescriptionGenerateButton
          isDisabled={isDisabled}
          locale={locale}
          textPrompt={textPrompt}
          generationType={generationType}
        />
      </div>
    </>
  )
}
